/**
 * vue-sparklines v2.0.1
 * (c) 2022 tangzhen@me.com
 * @license MIT
 */

import arrayMin from './min.js';
import arrayMax from './max.js';

var dataToPoints = (function (_ref) {
  var _ref$data = _ref.data,
      data = _ref$data === void 0 ? [] : _ref$data,
      _ref$limit = _ref.limit,
      limit = _ref$limit === void 0 ? 0 : _ref$limit,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 1 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 1 : _ref$height,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? 0 : _ref$margin,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? arrayMax(data) : _ref$max,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? arrayMin(data) : _ref$min,
      _ref$textHeight = _ref.textHeight,
      textHeight = _ref$textHeight === void 0 ? 0 : _ref$textHeight;
  var len = data.length;

  if (limit && limit < len) {
    data = data.slice(len - limit);
  }

  var vfactor = (height - margin * 2 - textHeight) / (max - min || 2);
  var hfactor = (width - margin * 2) / ((limit || len) - (len > 1 ? 1 : 0));
  return data.map(function (d, i) {
    return {
      x: i * hfactor + margin,
      y: (max === min ? 1 : max - d) * vfactor + margin + textHeight
    };
  });
});

export { dataToPoints as default };
//# sourceMappingURL=dataToPoints.js.map
